import React from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import PropTypes from 'prop-types';
import {
  ChevronDown,
  ChevronUp,
  CrossSvg,
} from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/form/form-base-components/templated-option-button/templated-option-button-head.css';


const StandardHead = React.memo(({
  selectedDisplayValue,
  placeholder,
  toggleOpenDropdown,
  clearValue,
  disabled,
  dropdownOpen,
}) => {

  const hasNoValue = selectedDisplayValue === '' || selectedDisplayValue === null;

  const closedWithValue = !hasNoValue && !dropdownOpen;

  // clearValue is optional
  const showClear = closedWithValue && clearValue;

  return (
    <div className="template-option-head template-option-head-standard">
      {
        showClear ? (
          <div className="template-option-head-button template-option-head-standard-button">
            <OptionButton
              onClick={toggleOpenDropdown}
              option={selectedDisplayValue}
              disabled={disabled}
            >
              <p>{selectedDisplayValue}</p>
            </OptionButton>
            <button
              type="button"
              className="svg-wrapper"
              onClick={clearValue}
              option={selectedDisplayValue}
              disabled={disabled}
            >
              <CrossSvg />
            </button>
          </div>
        ) : (
          <OptionButton
            className="template-option-head-button template-option-head-standard-button"
            onClick={toggleOpenDropdown}
            option={selectedDisplayValue}
            disabled={disabled}
          >
            <p>{!hasNoValue ? selectedDisplayValue : placeholder}</p>
            <div className="svg-wrapper">
              {
                dropdownOpen ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )
              }
            </div>
          </OptionButton>
        )
      }


    </div>
  );
});

StandardHead.propTypes = {
  selectedDisplayValue: PropTypes.string,
  placeholder: PropTypes.string,
  toggleOpenDropdown: PropTypes.func,
  clearValue: PropTypes.func,
  disabled: PropTypes.bool,
  dropdownOpen: PropTypes.bool,
};

export { StandardHead };

